(() => {
  const selector = '[data-add-to-cart-text][data-button-text-override]';

  document.addEventListener('theme:variant:change', (event) => {
    if (!event.detail?.variant?.available) return;

    event.target.querySelectorAll(selector).forEach((element) => {
      element.textContent = element.dataset.buttonTextOverride;
    });
  });

  const restoreInitialLabels = () => {
    document.querySelectorAll(selector).forEach((element) => {
      const button = element.closest('button');
      if (button && !button.disabled) {
        element.textContent = element.dataset.buttonTextOverride;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreInitialLabels, { once: true });
  } else {
    restoreInitialLabels();
  }
})();
